import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Clock, Package, Users, MessageCircle, ShieldAlert, ClipboardList } from 'lucide-react';

export function DeliveryRules({ defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);

  const rules = [
    {
      icon: Clock,
      title: 'Delivery Timing',
      items: [
        'The selected delivery date is a deadline, not an exact pickup time',
        'Preferred times are flexible and should be agreed between customer and driver',
      ],
    },
    {
      icon: Package,
      title: 'Packaging',
      items: [
        'Items must be securely packaged before the driver arrives',
        'Drivers can refuse items that are unsafe or poorly packaged',
      ],
    },
    {
      icon: Users,
      title: 'Availability',
      items: [
        'Customers must be available at pickup and drop-off locations',
        'Missed handovers may cause delays or additional charges',
      ],
    },
    {
      icon: MessageCircle,
      title: 'Communication',
      items: [
        'Use the platform or WhatsApp to communicate clearly with your driver or customer',
        'Share any special instructions when posting your job',
      ],
    },
    {
      icon: ShieldAlert,
      title: 'Prohibited Items',
      items: [
        'No illegal, hazardous, flammable, or unsafe goods',
        'No stolen property or items that violate Irish/EU law',
      ],
    },
    {
      icon: ClipboardList,
      title: 'Responsibility',
      items: [
        'Drivers are responsible for safe transport of items',
        'Customers must provide accurate job details (addresses, item size, weight)',
      ],
    },
  ];

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden bg-white" data-testid="delivery-rules">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-gray-50 transition-colors"
        data-testid="delivery-rules-toggle"
      >
        <span className="flex items-center gap-2 text-sm font-semibold text-gray-700">
          <ClipboardList className="w-4 h-4 text-[#2E7D32]" /> Delivery Rules
        </span>
        {open ? <ChevronUp className="w-4 h-4 text-gray-400" /> : <ChevronDown className="w-4 h-4 text-gray-400" />}
      </button>
      {open && (
        <div className="px-4 pb-4 border-t border-gray-100 pt-3">
          <div className="grid gap-4 sm:grid-cols-2">
            {rules.map(({ icon: Icon, title, items }) => (
              <div key={title} className="space-y-1.5">
                <h4 className="text-sm font-bold text-gray-800 flex items-center gap-2">
                  <Icon className="w-4 h-4 text-[#2E7D32]" /> {title}
                </h4>
                <ul className="text-xs text-gray-500 space-y-1 pl-6 list-disc">
                  {items.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              </div>
            ))}
          </div>
          <p className="mt-4 text-xs text-gray-400 italic text-center">Keep it simple and fair for everyone.</p>
        </div>
      )}
    </div>
  );
}
